'use es6';

import { Record, Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
import { getDateRangePresetForString, PRESET_TYPES } from '../../lib/AdsSimpleDateRange';
import { AttributionViews, CUSTOM_IDS, USERS_AND_TEAMS_TYPE } from '../../lib/Constants';
export default Record({
  usersAndTeams: ImmutableMap({
    id: CUSTOM_IDS.ALL,
    type: USERS_AND_TEAMS_TYPE.CUSTOM
  }),
  timeRange: getDateRangePresetForString(PRESET_TYPES.LAST_THIRTY_DAYS),
  statuses: ImmutableSet(),
  adAccounts: ImmutableSet(),
  attributionView: AttributionViews.FIRST_FORM_SUBMISSION,
  initialized: false
});